<template>
	<span class="content">
		<template v-if="message.from && message.from.nick"
			><Username :user="message.from" /> alterou o tópico para:
		</template>
		<template v-else>O tópico é: </template>
		<span v-if="message.text" class="new-topic"
			><ParsedMessage :network="network" :message="message"
		/></span>
	</span>
</template>

<script>
import ParsedMessage from "../ParsedMessage.vue";
import Username from "../Username.vue";

export default {
	name: "MessageTypeTopic",
	components: {
		ParsedMessage,
		Username,
	},
	props: {
		network: Object,
		message: Object,
	},
};
</script>
